
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.4 5.184a10.38 10.38 0 001.872 2.544A10.38 10.38 0 006.816 9.6l1.472-1.472a.619.619 0 01.32-.192.545.545 0 01.368.032c.704.245 1.493.368 2.368.368.181 0 .336.064.464.192a.632.632 0 01.192.464v2.352a.632.632 0 01-.192.464.632.632 0 01-.464.192 11.2 11.2 0 01-4.416-.896 11.299 11.299 0 01-3.6-2.432 11.299 11.299 0 01-2.432-3.6A11.194 11.194 0 010 .656C0 .475.064.32.192.192A.632.632 0 01.656 0h2.352c.181 0 .336.064.464.192a.632.632 0 01.192.464c0 .875.123 1.664.368 2.368.032.117.037.24.016.368a.533.533 0 01-.176.32L2.4 5.184z","fill":"#02203B","fill-rule":"evenodd"}})])
          )
        }
      }
    